import { TextInput } from '@mantine/core';
import type { ReactElement } from 'react';
import type { RuleBuilder } from './useRuleBuilder';

export const RuleNameInput = ({
  builder,
  description,
  onChange,
}: {
  builder: RuleBuilder;
  description?: string;
  /** Overrides the default name setter so the create flow can track manual edits. */
  onChange?: (name: string) => void;
}): ReactElement => {
  const { translate, ruleName, setRuleName } = builder;
  return (
    <TextInput
      label={translate('pages:rules.createModal.fields.ruleNameLabel')}
      placeholder={translate(
        'pages:rules.createModal.fields.ruleNamePlaceholder'
      )}
      description={description}
      inputWrapperOrder={['label', 'input', 'description', 'error']}
      maxLength={255}
      value={ruleName}
      onChange={(event) => (onChange ?? setRuleName)(event.currentTarget.value)}
      data-testid="rule-name-input"
    />
  );
};
